import { render } from "./PDeleteFav.vue?vue&type=template&id=213f498b"
import script from "./PDeleteFav.vue?vue&type=script&lang=js"
export * from "./PDeleteFav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__